import { io } from "socket.io-client";

const socket = io(`${process.env.REACT_APP_BACK_END_URL}`, { 
  path: '/sockets',
  origins: "*",
  transports: ['websocket']  // Force the use of WebSockets only
});

socket.on('connect', () => {
  console.log('Socket connected');
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected', reason);
});

export default socket